export type Size =
  | 'full'
  | 'max-w-[1600px]'
  | 'screen-md'
  | 'screen-xl'
  | 'max-w-[800px]'
  | 'max-w-5xl'
  | 'max-w-[640px]'
  | 'max-w-[576px]'
  | 'max-w-[1600px]';

export const sizeVariants: Record<Size, string> = {
  full: 'w-full',
  'max-w-[576px]': 'max-w-[576px] w-full mx-auto', // 576px
  'max-w-[640px]': 'max-w-[640px] w-full mx-auto', // 640px
  'screen-md': 'max-w-screen-md w-full mx-auto', // 768px
  'max-w-[800px]': 'max-w-[800px] w-full mx-auto', // 800px
  'max-w-5xl': 'max-w-5xl w-full mx-auto', // 1024px
  'screen-xl': 'max-w-screen-xl w-full mx-auto', // 1280px
  'max-w-[1600px]': 'max-w-[1600px] w-full mx-auto', // 1600px
};
